import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { Typography } from "@mui/material";

import LogoHeader from "../../components/LogoHeader";
import { Footer } from "../../components/Footer";


const OTPMaxAttemptReached = () => {
    const { t } = useTranslation();

    useEffect(
        () => {
            history.pushState(null, "", null);

            const callback = (event: any) => {
                history.pushState(null, "", null);
            };
            window.addEventListener("popstate", callback);

            return () => {
                window.removeEventListener("popstate", callback);
            };
        },
        []
    );

    return (
        <div style={{ height: "100%", maxHeight: "100%", padding: "14px 20px", position: "relative" }}>
            <LogoHeader enableLanguage={false}/>
            <Typography style={{ color: "#5888C4", fontWeight: 700, fontSize: 24, marginTop: "50%", textAlign: "center" }}>{t("tooManyRetries")}</Typography>
            <Typography style={{ color: "#666", marginTop: 32, textAlign: "center" }}>{t("thisPhoneNumberHasBeenTemporarilyBlocked")}</Typography>
            <div style={{ position: "absolute", bottom: 0, left: 0, right: 0 }}>
                <Footer marginBottom={0} />
            </div>
        </div>
    );
};

export default OTPMaxAttemptReached;
